export const SMALL_ICON_SIZE = 20
export const BIG_ICON_SIZE = 100
export const TOP_BAR_HEIGHT = 60
